import Vue from 'vue';
import store from 'store';
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
import { shadeFinderInteraction, trackFindMyShade } from 'lib/tracking';

export default (el) =>
  new Vue({
    components: {
      'vue-image': () => import('../vue-image/vue-image.vue'),
      'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
      modal: () => import('../modal/modal.vue'),
      'vto-results': () => import('../vto-results/vto-results.vue'),
      'vto-header': () => import('../vto-header/vto-header.vue'),
      'vto-product-description': () =>
        import('../vto-product-description/vto-product-description.vue'),
    },
    name: 'Shade Finder',
    el,
    store,
    mounted() {
      const filterKeysArray = this.$el.dataset.filterKeys
        .split(',')
        .map((key) => key.trim());

      this.setFilterGroups(filterKeysArray);
      window.ymkAsyncInit = () => {
        YMK.init();
      };
    },
    watch: {
      step(newValue) {
        const bodyEl = document.querySelector('body');
        const shadeFinderActiveClass = 'shade-finder--active';

        if (newValue === 1) {
          bodyEl.classList.remove(shadeFinderActiveClass);
        } else {
          bodyEl.classList.add(shadeFinderActiveClass);
        }
      },
    },
    computed: {
      ...mapGetters('vto', ['currentProduct']),
      ...mapState('vto', [
        'step',
        'recommendationIds',
        'filterGroups',
        'activeProduct',
      ]),
    },
    methods: {
      ...mapActions('global', ['openModal', 'closeModal']),
      ...mapActions('vto', [
        'setFiltersData',
        'processRecommendations',
        'setVtoStep',
      ]),
      ...mapMutations('vto', [
        'setVtoStep',
        'setState',
        'setRecommendations',
        'setFilterGroups',
      ]),
      openStepsModal() {
        this.openModal('vto-modal');
        trackFindMyShade({ action: 'find_my_shade_start', shopify_module_name: 'vto' });
        shadeFinderInteraction('Find your shade', undefined);
      },
      closeStepsModal() {
        this.closeModal();
      },
      initPC() {
        this.closeStepsModal();
        this.setVtoStep(2);
        YMK.openShadeFinder();
        YMK.addEventListener('shadeFinderComplete', async (results) => {
          YMK.enableCompare();

          await this.processRecommendations(results.recommendations);
          YMK.applyMakeupBySku(this.currentProduct.id);
          this.setVtoStep(3);
        });
        trackFindMyShade({ action: 'find_my_shade_take_selfie', shopify_module_name: 'vto' });
        shadeFinderInteraction('Take selfie', undefined);
      },
      handleScrollClick() {
        const destination = this.$el.offsetTop + this.$el.offsetHeight;
        window.scrollTo({
          top: destination,
          behavior: 'smooth',
        });
      },
    },
  });
